import React from "react";
import { Helmet } from "react-helmet-async";
import { ChevronDown, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const FaqVehicules = ({ setOpenIndex, openIndex, toggleFAQ, idCategorie }) => {
  const faqList = [
    {
      question: () => (
        <strong>
          1. Pourquoi payer pour publier mon annonce de véhicule sur Deal.mg ?
        </strong>
      ),
      answer: () => (
        <p>
          Votre paiement garantit un environnement sans spam, des utilisateurs
          sérieux et une visibilité accrue pour votre véhicule. De plus, vous
          accédez à des outils d'IA pour rédiger une annonce performante qui se
          démarque de la concurrence.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          2. Comment vérifier l'état d'un véhicule d'occasion avant l'achat ?
        </strong>
      ),
      answer: () => (
        <p>
          Pour sécuriser votre achat{" "}
          <strong>de voiture occasion à Madagascar</strong>, exigez des photos
          récentes et une vidéo du moteur en marche avant de conclure. Un
          vendeur sérieux sur <strong> Deal.mg</strong> fournira volontiers ces
          preuves par téléphone. Si vous ne pouvez pas vous déplacer, demandez à
          un mécanicien local de vérifier les points critiques (moteur,
          carrosserie, documents) pour confirmer que l'offre correspond à
          l'annonce.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          3. Comment rédiger une annonce automobile qui attire les acheteurs ?
        </strong>
      ),
      answer: () => (
        <p>
          Soyez précis sur la marque, le modèle, l'année, le kilométrage et
          l'état général. Incluez des photos de qualité sous tous les angles.
          L'utilisation de notre IA aide à rédiger une description exhaustive.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          4. Quels documents vérifier lors de l'achat d'une voiture ?
        </strong>
      ),
      answer: () => (
        <p>
          Exigez la carte grise, le certificat de non-gage, et le contrôle
          technique valide. Vérifiez que le numéro de châssis correspond à celui
          des documents officiels.
        </p>
      ),
    },
    {
      question: () => (
        <strong>5. Comment sécuriser le paiement d'un véhicule ?</strong>
      ),
      answer: () => (
        <p>
          Deal.mg ne joue pas le rôle d'intermédiaire financier. Ne versez
          jamais d'acompte à distance. Finalisez la vente en personne, de
          préférence par chèque de banque ou dans un lieu sécurisé.
        </p>
      ),
    },
    {
      question: () => (
        <strong>6. Comment fixer le juste prix de ma voiture à vendre ?</strong>
      ),
      answer: () => (
        <p>
          Comparez votre véhicule avec des modèles similaires publiés sur
          Deal.mg en tenant compte de l'état, de l'année et du kilométrage pour
          attirer rapidement des acheteurs.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          7. Quels documents vérifier pour l'achat d'un véhicule ?
        </strong>
      ),
      answer: () => (
        <p>
          Exigez la carte grise, le certificat de non-gage, et un contrôle
          technique valide. Vérifiez que le numéro de châssis correspond aux
          papiers.
        </p>
      ),
    },
    {
      question: () => (
        <strong>8. Comment signaler une annonce automobile suspecte ?</strong>
      ),
      answer: () => (
        <p>
          Si un prix est anormalement bas ou si les photos semblent volées,
          utilisez le bouton « Signaler » pour que notre équipe modère
          l'annonce.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          9. Comment trouver des pièces détachées ou des accessoires ?
        </strong>
      ),
      answer: () => (
        <p>
          Utilisez la barre de recherche en précisant la marque et la pièce
          recherchée dans la catégorie dédiée aux accessoires automobiles.
        </p>
      ),
    },
    {
      question: () => (
        <strong>
          10. Comment Deal.mg protège-t-il mes données personnelles ?
        </strong>
      ),
      answer: () => (
        <p>
          Votre numéro de téléphone est affiché pour permettre le contact
          direct, mais nous ne vendons pas vos données. Nous recommandons de
          rester vigilant face aux tentatives de phishing.
        </p>
      ),
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Achat et vente de véhicules d'occasion à Madagascar | Deal.mg
        </title>
        <meta
          name="description"
          content="Achetez ou vendez des voitures et motos d'occasion à Madagascar sur Deal.mg. Annonces fiables, utilisateurs sérieux et visibilité maximale."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            name: "Véhicules d'occasion à Madagascar",
            image: ["https://deal.mg/logo.png"],
            description:
              "Achetez et vendez des voitures et motos d'occasion à Madagascar sur Deal.mg",
            sku: idCategorie,
            offers: {
              "@type": "Offer",
              url: `https://deal.mg/article/resultat?idCategorie=${idCategorie}`,
              availability: "https://schema.org/InStock",
            },
          })}
        </script>
      </Helmet>

      <h1 className="text-center">
        Achat et vente de véhicules d'occasion à Madagascar
      </h1>

      <p>
        Le marché automobile malgache se trouve sur Deal.mg. Découvrez une large
        sélection de <strong>voitures occasion</strong> fiables et de{" "}
        <strong>motos d'occasion</strong>
        économiques, idéales pour naviguer à Antananarivo ou parcourir les
        routes nationales.
        <br />
        <br />
        En investissant dans la publication de votre annonce sur Deal.mg, vous
        garantissez à votre <strong>fiara amidy</strong> (voiture à vendre) une
        visibilité maximale auprès d'acheteurs sérieux.
      </p>

      <h2>Voitures d'occasion : trouvez la perle rare</h2>
      <p>
        Explorez notre large sélection d'automobiles : citadines pour
        {" "}<strong>Antananarivo</strong>, 4x4 pour les routes nationales, ou
        berlines familiales. Utilisez nos filtres par marque, modèle, année et
        kilométrage pour trouver le véhicule idéal. Pour chaque{" "}
        <strong>vente auto à Madagascar</strong>, Deal.mg s'efforce de
        promouvoir la transparence pour des transactions en toute sérénité.
      </p>

      <h2>Motos et scooters : roulez en toute liberté</h2>
      <p>
        Vous cherchez une <strong>moto occasion</strong> ou un scooter pour
        éviter les embouteillages ? Consultez nos annonces de deux-roues
        robustes et économiques. Acheter sur Deal.mg, c'est choisir la proximité
        et la confiance
      </p>

      <h2>Vendez votre véhicule au meilleur prix</h2>
      <p>
        Propriétaires, publiez votre annonce et utilisez notre outil d'IA pour
        générer une description détaillée et optimisée. Une annonce détaillée de
        plus de 300 mots améliore nettement son référencement sur Google,
        augmentant ainsi vos chances de vente rapide. Pour parfaire votre
        annonce, vous pouvez également consulter le matériel disponible dans la{" "}
        <Link to="/electronique/tous?categorie=6">
          <strong>catégorie Électronique</strong>
        </Link>{" "}
        ou des <strong>accessoires auto</strong> pour l'entretien de votre
        véhicule.
      </p>

      <br />

      <h2 className="support_faq_title">
        <MessageSquare size={20} className="support_faq_title_icon" />
        FAQ
      </h2>

      {faqList.map((item, index) => (
        <div
          key={index}
          className={`support_faq_item ${openIndex === index ? "open" : ""}`}
        >
          <div
            className="support_faq_question"
            onClick={() => toggleFAQ(index)}
          >
            <span>{item.question()}</span>
            <ChevronDown
              className={`support_faq_arrow ${
                openIndex === index ? "support_faq_rotate_180" : ""
              }`}
              size={20}
            />
          </div>

          <div
            className={`support_faq_answer_container${
              openIndex === index ? "active" : ""
            }`}
          >
            <div className="support_faq_answer">{item.answer()}</div>
          </div>
        </div>
      ))}
    </>
  );
};

export default FaqVehicules;
